import React from "react";

export default function Facts() {
  const metrics = [
    {
      number: "1,600",
      label: "Parish Families",
      desc: "Catholic households united in faith & worship",
      icon: "fas fa-home"
    },
    {
      number: "43",
      label: "Anbiyams",
      desc: "Basic Christian Communities actively sharing the Gospel",
      icon: "fas fa-bible"
    },
    {
      number: "14",
      label: "Substations",
      desc: "Mission chapels celebrating distinctive patronal feasts",
      icon: "fas fa-church"
    },
    {
      number: "5,000+",
      label: "Parishioners",
      desc: "Devout community members walking the path of Christ",
      icon: "fas fa-users"
    }
  ];

  return (
    <section id="facts" className="facts-section py-5" style={{ background: "linear-gradient(180deg, #fdfcf9 0%, #f7f4ed 100%)" }}>
      <div className="container py-4">
        <div className="section-heading-wrapper text-center mb-5">
          <div className="eyebrow-badge">
            <i className="fas fa-cross"></i>
            <span>Parish Vitality & Growth</span>
          </div>
          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy)" }}>
            Our Parish at a Glance
          </h2>
          <div className="cross-ornament">
            <i className="fas fa-cross"></i>
          </div>
          <p style={{ maxWidth: "680px", margin: "0 auto", color: "var(--cathedral-text-secondary)" }}>
            Under the grace of God and the patronage of Our Lady, St. Mary's Cathedral continues to flourish as a vibrant spiritual center in the Archdiocese of Madurai.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {metrics.map((item, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-lg-3">
              <div className="fact-card h-100 d-flex flex-column align-items-center justify-content-center">
                <div className="fact-icon-wrapper">
                  <i className={item.icon}></i>
                </div>
                <div className="fact-number">{item.number}</div>
                <h3 className="fact-label">{item.label}</h3>
                <p
                  className="mt-2 mb-0 text-center"
                  style={{ fontSize: "0.85rem", color: "#6e7f94", lineHeight: 1.5 }}
                >
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
